export {
  defineDatabase,
  defineModel,
  defineRegistry,
  defineSchema,
} from "./definitions.ts";
export type {
  AthenaSchemaSnapshot,
  DiffSchemasInput,
  DiffSchemasOptions,
  SchemaColumn,
  SchemaColumnType,
  SchemaDiff,
  SchemaDiffErrorCode,
  SchemaDiffOperation,
  SchemaDiffOperationKind,
  SchemaDiffSummary,
  SchemaForeignKey,
  SchemaIndex,
  SchemaNamespace,
  SchemaPrimaryKey,
  SchemaReferentialAction,
  SchemaSnapshotFromIntrospectionOptions,
  SchemaSnapshotFromModelsOptions,
  SchemaTable,
  SchemaTableIdentity,
  SchemaUniqueConstraint,
} from "./diff/index.ts";
// Canonical schema snapshot + structured schema diff (library API)
export {
  ATHENA_INTERNAL_SCHEMAS,
  ATHENA_SCHEMA_SNAPSHOT_VERSION,
  columnsEqual,
  columnTypesEqual,
  diffSchemas,
  emptySchemaSnapshot,
  isSchemaDiffEmpty,
  normalizeDefaultExpression,
  normalizeReferentialAction,
  normalizeSchemaColumnType,
  normalizeSchemaSnapshot,
  parseSchemaTypeString,
  primaryKeysEqual,
  SchemaDiffError,
  schemaSnapshotFromIntrospection,
  schemaSnapshotFromModels,
  summarizeSchemaDiffOperations,
  tableIdentityKey,
  validateSchemaSnapshot,
} from "./diff/index.ts";
export type {
  AthenaSchemaIr,
  NativeTypeDescriptor,
  SchemaConstraint,
  SchemaDatabase,
  SchemaEnum,
  SchemaMetadata,
  SchemaObjectId,
  SchemaObjectIdentity,
  SchemaRelation,
  SchemaType,
} from "./ir/index.ts";
export {
  ATHENA_SCHEMA_IR_KIND,
  ATHENA_SCHEMA_IR_VERSION,
  canonicalizeAthenaSchemaIr,
  fingerprintAthenaSchemaIr,
  SchemaIrError,
  schemaIrFromIntrospection,
  schemaIrFromModels,
  schemaIrFromSnapshot,
  schemaIrFromTable,
  schemaSnapshotFromIr,
  validateAthenaSchemaIr,
} from "./ir/index.ts";
export type {
  FormValuesOf,
  ModelFormAdapter,
  ModelFormDefaults,
  ModelFormNullishMode,
  ModelFormValues,
  ToModelFormDefaultsOptions,
  ToModelPayloadOptions,
} from "./model-form.ts";
export {
  createModelFormAdapter,
  toModelFormDefaults,
  toModelPayload,
} from "./model-form.ts";
export type {
  ModelSqlDialect,
  ModelSqlFile,
  ModelSqlInput,
  ModelSqlOptions,
  ModelsToSqlFilesOptions,
} from "./model-sql.ts";
export {
  collectModelsFromSqlInput,
  modelsToSql,
  modelsToSqlFiles,
  sqlD1,
  sqlPostgres,
  sqlSqlite,
} from "./model-sql.ts";
export type { PostgresIntrospectionProviderOptions } from "./postgres-provider.ts";
export { createPostgresIntrospectionProvider } from "./postgres-provider.ts";
export type {
  AthenaResolvedResource,
  AthenaResourceIdentity,
  AthenaResourceInput,
  AthenaResourceKind,
  AthenaResourceLookup,
  AthenaResourceRef,
} from "./resource.ts";
export {
  athenaResourceKeys,
  authResourceIdentity,
  canonicalAthenaResource,
  canonicalAthenaResourceIdentity,
  matchAthenaResource,
  normalizeAthenaResourceRef,
  parseAthenaResourceRef,
  relationResourceIdentity,
  resolveAthenaResourceFromPayload,
  resolvedAthenaResource,
  serviceResourceIdentity,
  storageObjectResourceIdentity,
} from "./resource.ts";
export type {
  AthenaTableDef,
  FormValuesFromColumns,
  InsertFromColumns,
  RowFromColumns,
  UpdateFromColumns,
} from "./table-builder.ts";
export { table } from "./table-builder.ts";
export type {
  AnyColumnBuilder,
  AthenaColumnBuilder,
  ColumnRuntimeConfig,
  DecimalColumnOptions,
} from "./table-columns.ts";
export {
  boolean,
  decimal,
  enumeration,
  json,
  number,
  numeric,
  string,
} from "./table-columns.ts";
export type { AthenaTableSchemaBundle } from "./table-schemas.ts";
export type {
  AthenaClientModelForTableName,
  AthenaClientModelsInput,
  AthenaClientTableName,
  AthenaModelTarget,
  DatabaseDef,
  InsertOf,
  IntrospectionColumn,
  IntrospectionInspectOptions,
  IntrospectionRelation,
  IntrospectionSchema,
  IntrospectionSnapshot,
  IntrospectionTable,
  IntrospectionTypeKind,
  ModelAt,
  ModelColumnKind,
  ModelColumnMetadata,
  ModelDef,
  ModelMetadata,
  ModelRelationKind,
  ModelRelationMetadata,
  RegistryDef,
  RowOf,
  SchemaDef,
  SchemaIntrospectionProvider,
  TenantContext,
  TenantContextValue,
  TenantKeyMap,
  UpdateOf,
} from "./types.ts";
